module.exports = __webpack_public_path__ + "static/img/IMG_20151229_153026.fef0f3f7.jpg";